import { useState } from "react";
import RecipeSlidePanel from "./RecipeSlidePanel";
import { PhotoIcon } from "@heroicons/react/24/outline";
import { useRecipeWithImage } from "../hooks/useRecipeWithImage";

export default function RecipeSummaryCardImage({ recipe }) {
  const [showPanel, setShowPanel] = useState(false);
  const { recipe: liveRecipe } = useRecipeWithImage(recipe._id, recipe);

  //const liveRecipe = recipe;
  if (!liveRecipe) {
    return (
      <div className="w-full h-48 flex items-center justify-center text-gray-400 bg-gray-100 animate-pulse rounded shadow">
        <PhotoIcon className="h-10 w-10" />
      </div>
    );
  }

  return (
    <>
      <div
        className="w-full overflow-hidden shadow rounded cursor-pointer hover:scale-[1.02] transition-transform duration-200 shadow"
        onClick={() => setShowPanel(true)} 
      >
        <div className="relative w-full h-48">
          {/* Image or Placeholder */}
          {liveRecipe.image ? (
            <img
              src={liveRecipe.image}
              alt={liveRecipe.name}
              className="w-full h-full object-cover opacity-0 transition-opacity duration-700"
              onLoad={(e) => (e.currentTarget.style.opacity = 1)}
            />
          ) : (
            <div className="w-full h-full bg-gray-200 flex items-center justify-center animate-pulse">
              <PhotoIcon className="h-8 w-8 text-gray-400" />
            </div>
          )}

          {/* Overlay with title and stats */}
          <div className="absolute bottom-0 w-full bg-gradient-to-t from-black/70 via-black/50 to-transparent text-white p-3">
            <h2 className="text-sm font-semibold truncate">{liveRecipe.name}</h2>
            <div className="text-xs mt-1 flex gap-2">
              <span>Prep: {liveRecipe.prepTime}</span>
              <span className="text-white/50">|</span>
              <span>Cook: {liveRecipe.cookTime}</span>
              <span className="text-white/50">|</span>
              <span>Serves: {liveRecipe.servings}</span>
            </div>
          </div>
        </div>
      </div>

      <RecipeSlidePanel
        isOpen={showPanel}
        onClose={() => setShowPanel(false)}
        recipe={liveRecipe}
      />
    </>
  );
}
